export default "__VITE_ASSET__CvqTosMq__"